export default __webpack_public_path__ + "static/Крысиные бега_3-31570fce11592eb90972bde6f87438eb.jpg";